import { GeneralCode, GeneralCodeType } from "models/content/GeneralCode";
import { makeRequest } from "./networkUtils";



export const addGeneralCodeDO = (type: GeneralCodeType, name: string, extra?:any): Promise<void> => {
    return makeRequest("general-codes", { method: "POST", body: { type, name,extra } })
}

export const getGeneralCodes = (type: GeneralCodeType|GeneralCodeType[]): Promise<GeneralCode[]> => {
  return makeRequest("general-codes?type=" + type)
}


export const updateGeneralCodeDO = async (id: number, name: string,isActive?:boolean): Promise<void> => {
    return makeRequest(`general-codes/${id}`, {
      method: "PUT",
      body: { name,isActive },
    });
};

export const updateGeneralCodesOrdinals = async (codes: { id: number; ordinal: number }[]): Promise<void> => {
    return makeRequest(`general-codes/ordinals`, {
      method: "PUT",
      body: { codes },
    });
};
